// @ts-nocheck
/* eslint-disable */

'use client';

import { Button, Chip, Column, Flex, Heading, Icon, ImageWrapper, Row, Separator, ShareModal, Spacer, variables } from 'daskapital-ds';
import { Suspense, useState } from 'react';

import { BlocksProps } from '@/lib/wordpress/_types/blocksStyle';
import GravityForm from '@/components/common/GravityForm/GravityForm';
import NavigationEvents from '@/components/common/NavigationEvents/NavigationEvents';
import displayBlock from '@/lib/wordpress/blocks/displayBlock';
import { useGlobalContext } from '@/lib/globalContext';

const CareersPost = (props: Record<string, unknown>) => {
	const { post, careersBlock, lastNews, formData } = props;
	const state = useGlobalContext();
	const [shareOpen, setShareOpen] = useState(false);

	const { image, title, translatedURI, blocks, date, news } = post;

	return (
		<div>
			<Suspense>
				<NavigationEvents translatedURI={translatedURI || ''} acf={{ page_style: 'light', header_absolute: false }} />
			</Suspense>
			<Spacer customHeight={'6rem'} />
			<Row>
				<Column lg={1}></Column>
				<Column lg={10}>
					<Flex gap="12px" justify="space-between" wrap="nowrap" className="w-100">
						<Heading tag="h1" size="h3">
							{title}
						</Heading>

						<Button variant="primary" rightIcon={<Icon icon="icon-share" />} onClick={() => setShareOpen(true)}></Button>
					</Flex>

					<Spacer customHeight="3rem" />
					<Separator color={variables.colors.gray40} height={'1px'} className={'gray50'} />

					<Spacer customHeight="3rem" />
				</Column>
				<Column lg={1}></Column>
			</Row>
			<Row>
				<Column lg={1}></Column>
				<Column lg={10}>
					{!!(blocks as [])?.length &&
						(blocks as []).map((block: BlocksProps, index: number) => {
							return displayBlock(block, index);
						})}
				</Column>
				<Column lg={1}></Column>
				{/* </Column>
				<Column lg={1}></Column> */}
				{/* <Column lg={4}>
					<GravityForm formData={formData} formId={process.env.NEXT_PUBLIC_HIRING_FORM_ID} />
				</Column> */}
				{/* <Column lg={1}></Column> */}
			</Row>

			<Spacer height={8} />
			<div>
				{!!(careersBlock?.blocks as [])?.length &&
					(careersBlock?.blocks as []).map((block: BlocksProps, index: number) => {
						return displayBlock(block, index);
					})}
			</div>

			<Spacer height={11} />
			<div>
				{!!(lastNews?.blocks as [])?.length &&
					(lastNews?.blocks as []).map((block: BlocksProps, index: number) => {
						return displayBlock(block, index);
					})}
			</div>

			<Spacer height={10} />

			<ShareModal
				siteTitle={process.env.NEXT_PUBLIC_SITE_NAME}
				title={post.title}
				url={`${process.env.NEXT_PUBLIC_FE_URL}${post.slug}`}
				label={(state?.dict?.blog as Record<string, string>).shareBtn}
				copyText={(state?.dict?.blog as Record<string, string>).shareCopy}
				open={shareOpen}
				onClose={() => setShareOpen(false)}
				className="color-primary50"></ShareModal>
		</div>
	);
};
export default CareersPost;
